var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "7935ec95c421cee6d86eb22ecd136d5f"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    fill: ""
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M345.363,141.465H220.758v-34.14h124.605V141.465z M379.346,194.327H220.758v35.242h158.588 V194.327z M379.346,282.431H220.758v35.241h158.588V282.431z M379.346,370.534H220.758v35.242h158.588V370.534z M320.433,35.742 H79.793V476.26h352.414V147.512L320.433,35.742 M335.032,0.5l132.416,132.415V511.5H44.551V0.5H335.032L335.032,0.5z  M167.896,194.327h-35.242v35.242h35.242V194.327z M167.896,106.224h-35.242v35.242h35.242V106.224z M167.896,282.431h-35.242 v35.241h35.242V282.431z M167.896,370.534h-35.242v35.242h35.242V370.534z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsIcon);
export default __webpack_public_path__ + "static/media/projects-icon.ef3f0cec90d6e2f0eb8acf51c804f92c.svg";
export { ForwardRef as ReactComponent };